export const LoadingState = ({ message = 'Cargando...', className = '' }) => {
  return (
    <div className={`text-center py-20 ${className}`}>
      <div className="animate-spin rounded-full h-12 w-12 border-b-3 border-indigo-600 mx-auto mb-4" />
      <p className="text-gray-600 dark:text-gray-400">{message}</p>
    </div>
  );
};

